import styled from '@emotion/styled';
import { Button as MuiButton } from '@mui/material';
import type { ButtonProps } from '@mui/material';

import {
  blueUltramarine300,
  blueUltramarine800,
  borderStyle,
  borderWidth,
  labelSmallStrongFontFamily,
  labelSmallStrongFontSize,
  labelSmallStrongFontWeight,
  labelSmallStrongLetterSpacing,
  lineHeights1,
  lineHeights6,
  transparent,
  white,
} from '../../../theme/videa-style-tokens';

const Button = styled(MuiButton)<ButtonProps>`
  font-family: ${labelSmallStrongFontFamily}, sans-serif;
  background-color: ${blueUltramarine300};
  color: ${white};
  border: ${borderWidth} ${borderStyle} ${transparent};
  text-transform: initial;
  font-size: ${labelSmallStrongFontSize};
  letter-spacing: ${labelSmallStrongLetterSpacing};
  font-weight: ${labelSmallStrongFontWeight};
  padding: 0.34em 0.65em;
  margin: 0.1em;
  min-height: 2em;
  line-height: ${lineHeights6};

  :hover {
    border: ${borderWidth} ${borderStyle} ${transparent};
    background-color: ${blueUltramarine800};
    color: ${white};
  }

  svg {
    pointer-events: none;
  }
`;

export const VideaButton = <C extends React.ElementType>(
  props: ButtonProps<C, { component?: C }>,
) => {
  const { children } = props;
  return <Button {...props}>{children}</Button>;
};

export const VideaTextButton = styled(VideaButton)`
  font-family: ${labelSmallStrongFontFamily}, sans-serif;
  background-color: ${transparent};
  color: black;
  border: none;
  padding: 0;
  line-height: ${lineHeights1};
  border: ${borderWidth} ${borderStyle} ${transparent};

  &:hover {
    border: ${borderWidth} ${borderStyle} ${transparent};
    background-color: ${transparent};
    color: ${blueUltramarine800};
  }
`;
